<template>
  <a
    class="lang-switch-btn"
    :class="{ 'drawer-mode': drawer }"
    id="lang-btn"
    @click="changeLanguage"
    :title="$t('Change Language')"
  >
    <!-- <img :src="langPathImg" /> -->
    <v-icon :size="drawer ? 28 : 16" :color="iconColor"> mdi-web </v-icon>
    <span class="lang-text">{{ lang }}</span>
  </a>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js"

export default {
  name: "locale-changer",
  mixins: [GlobalMixin],
  props: ["isScrolled", "drawer"],
  mounted() {
    document.documentElement.lang = this.$i18n.locale
    document.documentElement.dir = this.$i18n.locale === "en" ? "ltr" : "rtl"
    this.$vuetify.rtl = this.$i18n.locale === "ar"
  },
  computed: {
    lang() {
      return this.$i18n.locale === "en" ? "EN" : "عربي"
    },
    iconColor() {
      if (this.drawer) return "rgb(56,56,56)"
      return this.isScrolled ? "rgb(56, 56, 56)" : "#fff"
    },
  },
  methods: {
    changeLanguage() {
      localStorage.setItem(
        "preferred-lang",
        this.$i18n.locale === "en" ? "ar" : "en"
      )
      this.changeLang()
    },
  },
}
</script>
<style scoped lang="scss">
.lang-switch-btn {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 7px 17px;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    /* background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    ); */
    transition: left 0.5s ease;
  }

  &:hover::before {
    left: 100%;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-1px);
  }

  &.drawer-mode {
    justify-content: flex-start;
    width: 100%;
    padding: 0;
    margin: 0;
  }
}

.lang-switch-btn:hover {
  i,
  .lang-text {
    color: $darker-green !important;
  }
}
.lang-switch-btn span {
  margin-left: 2px;
  font-weight: 600;
  font-size: 14px;
}
</style>
